import { Injectable } from '@angular/core';
import { Action } from '../model/action';
import { Procedure } from '../model/procedure';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class ProcedureService {

  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : Procedure;
  constructor(http : HttpClientService, cook : CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
  saveProcedure() : Observable<Procedure> {   
     this.objAction.header = null;
     this.objAction.data = this.data;
     this.objAction.path = 'api/Procedures/CreateProcedures';
     return this.objAction.save();
  }
   getProcedures() :   Observable<Procedure[]> {
     this.objAction.path = 'api/Procedures/GetProcedures'
    return this.objAction.get();
  }
  updateProcedure() : Observable<Procedure> {   
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Procedures/UpdateProcedures'
    return this.objAction.update();
  }
  deleteProcedure(org : Procedure) : Observable<Procedure> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = 'api/Procedures/DeleteProcedures?strProceduresId=' + org.ProcedureId; 
    return this.objAction.delete();
 }

}



// WEBPACK FOOTER //
// ./src/app/section/master/services/procedure.service.ts